import { render } from "./SettingUsers.vue?vue&type=template&id=7e09fb0a&scoped=true&ts=true&lang=pug"
import script from "./SettingUsers.vue?vue&type=script&lang=ts"
export * from "./SettingUsers.vue?vue&type=script&lang=ts"

import "./SettingUsers.vue?vue&type=style&index=0&id=7e09fb0a&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e09fb0a"]])

export default __exports__